import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { resetFactorSetDepartures } from '../../../../reducers/factorSetDepartureReducer';
import { FormType } from '../../../../constants/constants';
import AddFactorSetDepartureForm from './addFactorSetDepartureForm';

interface IAddFactorSetDepartureProps {
    classes: any;
    theme: Theme;
    match: any;
    resetFactorSetDepartures: any;
    steps: Array<number>;
    factorSetDepartureId?: number;
    factorSetVersionId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetFactorSetDepartures: () => dispatch(resetFactorSetDepartures())
});

const mapStoreToProps = (store: RootState, ownProps: IAddFactorSetDepartureProps) => {
    return {
        factorSetDepartureId: ownProps.match.params?.departureId ? Number(ownProps.match.params?.departureId) : undefined,
        factorSetVersionId: ownProps.match.params?.factorSetVersionId ? Number(ownProps.match.params?.factorSetVersionId) : undefined
    };
};

class AddFactorSetDeparture extends Component<IAddFactorSetDepartureProps> {
    componentWillUnmount() {
        const { resetFactorSetDepartures } = this.props;

        resetFactorSetDepartures();
    }

    render() {
        const { classes, steps, factorSetDepartureId, type, factorSetVersionId } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <AddFactorSetDepartureForm factorSetDepartureId={factorSetDepartureId} steps={steps} type={type} factorSetVersionId={factorSetVersionId} />
                </CardContent>
            </Card>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddFactorSetDeparture));